/** Je li narudžba pouzeće? WooCommerce trgovine koriste ili `cod` gateway ili
 *  vlastiti gateway čiji naslov sadrži „pouzeć…" — jedina definicija za cijelu app. */
export function isCodOrder(order: { payment_method?: string | null; payment_method_title?: string | null }): boolean {
  return order.payment_method === "cod" || !!order.payment_method_title?.toLowerCase().includes("pouzeć");
}
